import React, { useContext, useEffect, useRef, useState } from "react";
import useLongPress from "../../helpFunction/longPress";

import { Adress } from "../../helpFunction/urlList";
import { hawManyFiles, paramsQuery } from "../../helpFunction/helpFunction";
import { ContextHome } from "../../contextHomeCloude/contextHome";
import { CiEdit } from "react-icons/ci";
import { RenameFile } from "./../menu/renameFile/renameFile";
import { FaRegCirclePlay } from "react-icons/fa6";

import "./DataListFtp.css";
import { SingleItemView } from "../menu/SingleItemView/SingleItemView";
import { SmallSpiner } from "../../spinerListki/spiner";

export interface propsFileName {
	old: string;
	new: string;
}
export const DataListFtp = () => {
	// const [Item, setItem] = useState<string>("");

	const [newFileName, setNewFileName] = useState<propsFileName | null>(null);

	const [singleItem, setSingleItem] = useState<string>("");
	const refSpiner = useRef<HTMLDivElement[] | null[]>([]);
	const refSlider = useRef<HTMLDivElement>(null);
	const refSliderPosition = useRef<HTMLDivElement>(null);
	const refPath = useRef<HTMLDivElement>(null);
	const [listStyle, setListStyle] = useState({ "padding-right": "0px" });

	const refList = useRef<HTMLDivElement>(null);
	const ekranHeight = window.innerHeight;
	const context = useContext(ContextHome);

	const menuHeight = document.querySelector(".menu")?.clientHeight;
	const stopkaHeight = document.querySelector(".stopka")?.clientHeight;

	useEffect(() => {
		const PathHeight = refPath?.current?.clientHeight;
		const listHeight = refList?.current?.clientHeight;

		if (menuHeight && PathHeight && refSlider.current && refSliderPosition.current && listHeight && stopkaHeight) {
			if (menuHeight && PathHeight && refSlider.current && refSliderPosition.current && listHeight) {
				const headerHeight = menuHeight + PathHeight;

				refSlider.current.style.top = headerHeight + "px";
				refSlider.current.style.bottom = stopkaHeight + "px";
				const wysokosc = window.screen.height - headerHeight - stopkaHeight - 4;

				const sliderHeight = (wysokosc / (listHeight / wysokosc)).toFixed();

				refSliderPosition.current.style.height = sliderHeight + "px";

				if (listHeight < window.screen.height) {
					refSlider.current.style.display = "none";
					refSliderPosition.current.style.display = "none";
					setListStyle({ "padding-right": "0" });
				} else {
					refSlider.current.style.display = "block";
					refSliderPosition.current.style.display = "block";
					setListStyle({ "padding-right": "5px" });
				}
			}
		}
	}, [context?.data]);
	const windowScroll = () => {
		const PathHeight = refPath?.current?.clientHeight;
		const listHeight = refList?.current?.clientHeight;

		if (listHeight && refSliderPosition.current && PathHeight && menuHeight && stopkaHeight && refSlider.current) {
			const tauchPoint = (window.pageYOffset as number) - (menuHeight + PathHeight);
			const scrollPoint = (window.pageYOffset * listHeight) / ekranHeight;

			const maxScroll = tauchPoint + menuHeight + PathHeight + stopkaHeight + parseInt(refSliderPosition.current.style.height.replace("px", "")) - ekranHeight;

			const scroll = (window.pageYOffset * refSlider.current.clientHeight) / listHeight;

			refSliderPosition.current.style.top = scroll.toFixed() + "px";
			if (maxScroll >= 0) {
				refSliderPosition.current.style.top = scroll.toFixed() + "px";
			}

			if (scrollPoint < 75) refSliderPosition.current.style.top = 0 + "px";
		}
	};

	window.addEventListener("scroll", windowScroll);

	if (!context) return null;
	const { connect, data, setReload, reload, path, setPath, LongPressed, setLongPressed, selectedFiles, setSelectedFiles, loadingProgress, setMenuEnabled, setFirstTach, firstTach } = context;

	const onLongPress = (e: any) => {
		const item = e.target.attributes.about?.value;
		if (LongPressed) return;

		// setItem(item);
		setSelectedFiles([item]);
		e.target?.classList.add("selected");

		setLongPressed(true);
		setFirstTach(true);
	};

	const onClick = async (e: any) => {
		let fileType;
		let name;

		if (e.alt || e.abaut) {
			fileType = Number(e.alt);
			name = e.about;
		} else {
			fileType = Number(e.target.attributes.alt?.value);
			name = e.target.attributes.about?.value;
		}

		if (!LongPressed) {
			await goInFile(name, e, fileType);
		} else {
			console.log(e);

			selectingFiles(name, e);
		}
	};

	const selectingFiles = async (fileName: string, e?: any) => {
		e.target?.classList.add("selected");
		if (firstTach) {
			e.target?.classList.add("selected");
			setSelectedFiles([...selectedFiles, fileName]);
			// setItem(Item + fileName);
			setFirstTach(false);
			return;
		}
		if (selectedFiles.includes(fileName)) {
			e.target?.classList.remove("selected");
			setSelectedFiles(
				selectedFiles.filter((e) => {
					return e !== fileName;
				}),
			);
		} else {
			e.target?.classList.add("selected");
			setSelectedFiles([...selectedFiles, fileName]);
			// setItem(Item + fileName);
		}
	};
	const defaultOptions = {
		shouldPreventDefault: false,
		delay: 500,
	};
	// eslint-disable-next-line react-hooks/rules-of-hooks
	const longPressEvent = useLongPress(onLongPress, onClick, defaultOptions);

	const goInFile = async (name: string, e?: any, fileType?: number) => {
		if (LongPressed) {
			selectingFiles(name, e);
			return;
		}

		if (fileType === 2) {
			setPath(path + "/" + name);
			setReload(!reload);
			return;
		}
		if (fileType === 1) {
			if (!name || !path) return;

			setSingleItem(name);
			setMenuEnabled(false);
			document.querySelector(".list")?.classList.add("disabled");
		}
	};
	const renameFile = (name: any) => {
		setNewFileName({ old: name, new: "" });
	};
	const sliderMove = (e: any) => {
		const PathHeight = refPath?.current?.clientHeight;
		const listHeight = refList?.current?.clientHeight;

		if (listHeight && refSliderPosition.current && PathHeight && menuHeight && stopkaHeight) {
			const tauchPoint = (e.touches[0].clientY as number) - (menuHeight + PathHeight);
			const scrollPoint = (tauchPoint * listHeight) / ekranHeight;

			window.scrollTo({ left: 0, top: scrollPoint, behavior: "smooth" });

			const maxScroll = tauchPoint + menuHeight + PathHeight + stopkaHeight + parseInt(refSliderPosition.current.style.height.replace("px", "")) - ekranHeight;
			const scroll = ekranHeight - menuHeight - PathHeight - stopkaHeight - parseInt(refSliderPosition.current.style.height.replace("px", ""));

			refSliderPosition.current.style.top = tauchPoint.toFixed() + "px";
			if (maxScroll >= 0) {
				refSliderPosition.current.style.top = scroll.toFixed() + "px";
			}

			if (scrollPoint < 75) refSliderPosition.current.style.top = 0 + "px";
		}
	};

	return (
		<>
			{!singleItem && (
				<>
					<div className="path" ref={refPath}>
						<div className="MenuPath">
							<p className="MenuPath_P">chmura:{path}</p>
							<p className="MenuPath_F">
								{hawManyFiles(data).folders}/{hawManyFiles(data).files}
							</p>
						</div>
					</div>
					<div className="list" style={{ paddingRight: listStyle["padding-right"] }} ref={refList}>
						{data.length === 0 && connect && (
							<div className="pustaLista">
								<p>. . . Brak plików do wyświetlenia . . .</p>
							</div>
						)}
						{data.map((e, i: number) => {
							let type: string;
							let icon = "";
							let fileType = "folder";
							let video = false;

							if (e.type === 1) {
								const index = e.name.lastIndexOf(".");
								fileType = e.name.slice(index + 1, e.name.length).toLowerCase();
							}
							if (e.type === 2) {
								fileType = "folder";
							}

							try {
								if (fileType !== "folder") {
									if (fileType === "jpg" || fileType === "jpeg" || fileType === "png" || fileType === "webp") {
										type = Adress.smallImage;
										icon = `${type}/?${paramsQuery(e.path, e.name)}`;
									}
									if (
										fileType === "avi" ||
										fileType === "mp4" ||
										fileType === "mov" ||
										fileType === "mpeg" ||
										fileType === "mpg" ||
										fileType === "webm" ||
										fileType === "ogg"
									) {
										type = Adress.frameFromVideo;
										icon = `${type}/?${paramsQuery(e.path, e.name)}`;
										video = true;
									}
									if (icon === "") {
										icon = require(`../../assets/${fileType}.png`);
									}
								} else {
									icon = require(`../../assets/${fileType}.png`);
								}
							} catch (error) {
								icon = require(`../../assets/unknow.png`);
							}

							return (
								<div className="list-item" key={e.name}>
									<div className="img_div">
										<>
											<img
												src={icon}
												// onError={({ currentTarget }) => {
												// 	currentTarget.onerror = null;
												// 	currentTarget.src = `${type}/?${paramsQuery(e.path, e.name)}`;
												// }}
												className="lazy img"
												loading="lazy"
												about={e.name}
												alt={e.type.toString()}
												{...longPressEvent}
												onLoad={() => refSpiner.current[i]?.classList.add("spinerDisabled")}
											/>

											<FaRegCirclePlay
												className="videoPlayIcon"
												title={e.type.toString()}
												style={{ display: video ? "block" : "none", zIndex: "0" }}
												onClick={(a) => onClick({ alt: e.type.toString(), about: e.name, e: a })}
											/>

											<div
												className="spinerOnLoad"
												ref={(el) => {
													refSpiner.current[i] = el;
												}}
											>
												<SmallSpiner progress={loadingProgress} />
											</div>
										</>
									</div>
									<p className="list-item-data">{e.name}</p>
									{e.type === 1 && (
										<>
											<div className="size">
												<p>
													{e.size > 0 &&
														(e.size / 1024 < 1
															? (e.size / 1024).toFixed(2) + "KB"
															: e.size / 1024 / 1024 > 1024
																? (e.size / 1024 / 1024 / 1024).toFixed(2) + "GB"
																: (e.size / 1024 / 1024).toFixed(2) + " MB")}
												</p>
												<CiEdit className="iconEdit" onClick={() => renameFile(e.name)} />
											</div>
										</>
									)}
									{e.type === 2 && <CiEdit className="iconEdit" onClick={() => renameFile(e.name)} />}
								</div>
							);
						})}
					</div>
				</>
			)}
			{newFileName && <RenameFile newFileName={newFileName} setNewFileName={setNewFileName} path={path} />}
			{singleItem && <SingleItemView setSingleItem={setSingleItem} fileName={singleItem} />}

			<div className="slider" ref={refSlider}>
				<div
					className="sliderPosition"
					ref={refSliderPosition}
					onTouchMove={(e: any) => {
						sliderMove(e);
					}}
				>
					<div className="nic"></div>
				</div>
			</div>
			{/* )} */}
		</>
	);
};
